// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__Q1lNK","title":"styles_title__vsd0L","list":"styles_list__M3Lnu"};
module.exports.__checksum = "db0af857dbfd"
